import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["originalItem"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
import { request, sleep } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { casingWines, purchaseOrder, listContinents, STOCK_PART } from "@/js/lists.ts";
import { getErrorData } from "@/js/forms.js";
import { wineNaming } from "@/js/wine/wine.js";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import MailTemplateModal from "@/components/mail/MailTemplateModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  components: {
    MailTemplateModal: MailTemplateModal,
    MailTemplateForm: MailTemplateForm,
    Confirm: Confirm
  },
  props: {
    loggedUserData: Object,
    isShown: false,
    dialog: Boolean,
    order: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      drawer: false,
      drawerWidth: "80%",
      isSourcingAvailable: false,
      steps: [],
      currentStep: 1,
      openedPanel: 0,
      isStatelessDrawer: true,
      isValidating: false,
      splitOrderCancellationToken: null,
      form: {
        newOrderItems: [],
        emailTemplates: [{
          id: 0,
          sendTo: [],
          files: [],
          mailHistories: []
        }]
      },
      quantityToggleKey: false,
      filterIntegerKey: filterIntegerKey,
      itemsSearchFromWinery: false,
      itemsSearchLabel: null,
      itemsShown: [],
      templateModalShown: false,
      editableTemplate: {},
      emailPlaceholders: {},
      emailTemplates: [],
      isSuccessfulSending: {},
      hasFailedSending: false,
      failedCustomMails: {},
      isDeletingTemplate: false,
      documents: [],
      isLoadingFiles: false,
      isSyncing: false,
      isNeedingSync: false,
      isSendNotificationMails: false,
      casingWines: casingWines,
      purchaseOrder: purchaseOrder,
      URL: URL,
      STOCK_PART: STOCK_PART
    };
  },
  computed: {
    isInvalidMainForm: function isInvalidMainForm() {
      var _this2 = this;
      if (!this.hasItemsChosen) return true;
      if (this.form.newOrderItems.length === this.order.items.length) {
        var isAnyItemNotFull = this.form.newOrderItems.some(function (x) {
          var _this2$order$items$fi;
          return x.nbBottles < (_this2.order.items.some(function (oItem) {
            return oItem.id_item == x.fromItemId;
          }) ? (_this2$order$items$fi = _this2.order.items.find(function (oItem) {
            return oItem.id_item == x.fromItemId;
          })) === null || _this2$order$items$fi === void 0 ? void 0 : _this2$order$items$fi.quantity : 0);
        });
        if (!isAnyItemNotFull) return true;
      }
      var nullishPredicate = function nullishPredicate(x) {
        var _x$sendTo;
        return !x.id || !x.from || !((_x$sendTo = x.sendTo) !== null && _x$sendTo !== void 0 && _x$sendTo.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
      };
      if (this.form.emailTemplates.some(nullishPredicate)) return true;
      return false;
    },
    errorsMainForm: function errorsMainForm() {
      var _this3 = this;
      if (this.isInvalidMainForm) {
        var errors = [];
        if (!this.hasItemsChosen) {
          errors.push("You must select at least one item to split.");
        }
        if (this.form.newOrderItems.length === this.order.items.length) {
          var isAnyItemNotFull = this.form.newOrderItems.some(function (x) {
            var _this3$order$items$fi;
            return x.nbBottles < _this3.order.items.some(function (oItem) {
              return oItem.id_item == x.fromItemId;
            }) ? (_this3$order$items$fi = _this3.order.items.find(function (oItem) {
              return oItem.id_item == x.fromItemId;
            })) === null || _this3$order$items$fi === void 0 ? void 0 : _this3$order$items$fi.quantity : 0;
          });
          if (!isAnyItemNotFull) {
            errors.push("You can't select the full order.");
          }
        }
        var nullishPredicate = function nullishPredicate(x) {
          var _x$sendTo2;
          return !x.id || !x.from || !((_x$sendTo2 = x.sendTo) !== null && _x$sendTo2 !== void 0 && _x$sendTo2.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
        };
        if (this.form.emailTemplates.some(nullishPredicate)) errors.push("At least one mail configured is still not set correctly. You should delete it, or configure it completely.");
        return errors;
      }
      return null;
    },
    hasItemsChosen: function hasItemsChosen() {
      return this.form.newOrderItems.length > 0;
    },
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders).flat();
    }
  },
  watch: {
    isShown: function () {
      var _isShown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(visible) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.drawer = visible;
              this.closureAttempt = 0;
              if (visible) {
                this.itemsSearchLabel = null;
                this.initStep();
                this.initNewOrderItems();
                this.fetchEmailPlaceholders();
                this.fetchEmailTemplates();
                this.fetchOrderDocuments();
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function isShown(_x) {
        return _isShown.apply(this, arguments);
      }
      return isShown;
    }(),
    currentStep: function currentStep(_currentStep) {
      if (this.steps.filter(function (x) {
        return ["items", "mail"].includes(x.key);
      }).map(function (x) {
        return x.id;
      }).includes(_currentStep)) {
        this.drawerWidth = "80%";
      } else {
        this.drawerWidth = "45%";
      }
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var canAccessPoData;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            canAccessPoData = hasRole(process.env.VUE_APP_ROLES_ACCESS_SOURCING) || hasRole(process.env.VUE_APP_ROLES_MANAGE_PURCHASE_ORDERS);
            _this4.isSourcingAvailable = _this4.$whitelabel.isAllowedToAccessPurchaseOrder && canAccessPoData;
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    validateMain: function validateMain() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isConfirmed, _this5$splitOrderCanc, items, data, _this, path, _, _loop, i;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.$refs.confirm.open("Order split", "Are you sure about this order split ?");
            case 2:
              isConfirmed = _context6.sent;
              if (!isConfirmed) {
                _context6.next = 22;
                break;
              }
              _this5.isValidating = true;
              (_this5$splitOrderCanc = _this5.splitOrderCancellationToken) === null || _this5$splitOrderCanc === void 0 || _this5$splitOrderCanc.cancel();
              _this5.splitOrderCancellationToken = axios.CancelToken.source();
              items = _this5.form.newOrderItems.map(function (_ref) {
                var originalItem = _ref.originalItem,
                  item = _objectWithoutProperties(_ref, _excluded);
                return item;
              });
              data = {
                items: items
              };
              _this = _this5;
              path = "/v1/orders/" + _this.order.id_order + "/split";
              _context6.next = 13;
              return request(path, "post", data, true, "api", null, _this.splitOrderCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, null, true);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                _this.isValidating = false;
                throw e;
              });
            case 13:
              _ = _context6.sent;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
                var template, formData, _this;
                return _regeneratorRuntime().wrap(function _loop$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      template = _this5.form.emailTemplates[i];
                      template.templateId = template.id;
                      formData = new FormData();
                      Object.keys(template).forEach(function (key) {
                        return formData.append(key, template[key]);
                      });
                      template.files.forEach(function (x) {
                        formData.append("files", !x.blob ? x : new File([x.blob], x.id));
                      });
                      _this = _this5;
                      _context5.next = 8;
                      return request("/v1/mail/send", "post", formData, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                          while (1) switch (_context3.prev = _context3.next) {
                            case 0:
                              _this.isSuccessfulSending = _objectSpread(_objectSpread({}, _this.isSuccessfulSending), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                              _context3.next = 3;
                              return sleep(100);
                            case 3:
                            case "end":
                              return _context3.stop();
                          }
                        }, _callee3);
                      }))).catch(/*#__PURE__*/function () {
                        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                            while (1) switch (_context4.prev = _context4.next) {
                              case 0:
                                _this.hasFailedSending = true;
                                _this.failedCustomMails = _objectSpread(_objectSpread({}, _this.failedCustomMails), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                                _context4.next = 4;
                                return sleep(100);
                              case 4:
                              case "end":
                                return _context4.stop();
                            }
                          }, _callee4);
                        }));
                        return function (_x2) {
                          return _ref3.apply(this, arguments);
                        };
                      }());
                    case 8:
                    case "end":
                      return _context5.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 16:
              if (!(i < _this5.form.emailTemplates.length)) {
                _context6.next = 21;
                break;
              }
              return _context6.delegateYield(_loop(i), "t0", 18);
            case 18:
              i++;
              _context6.next = 16;
              break;
            case 21:
              _this5.acknowledgeValidation();
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee5);
      }))();
    },
    acknowledgeValidation: function acknowledgeValidation() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.$emit("validate", true, function () {
                if (!_this6.hasFailedSending) _this6.$emit("close", true);
                _this6.initNewOrderItems();
                _this6.isValidating = false;
                _this6.$toasted.show("Order succesfully split.", {
                  type: "success"
                });
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee6);
      }))();
    },
    initNewOrderItems: function initNewOrderItems() {
      this.form.newOrderItems = [];
      this.itemsShown = [];
    },
    itemsSearch: function itemsSearch() {
      var _this7 = this;
      var result = [];
      if (!this.itemsSearchLabel) {
        result = this.order.items.filter(function (item) {
          return !!_this7.itemsSearchFromWinery && item.isDirectWinery || _this7.form.newOrderItems.map(function (x) {
            return x.fromItemId;
          }).includes(item.id_item);
        });
      } else {
        result = this.order.items.filter(function (item) {
          return String.removeDiacritics(_this7.itemsSearchLabel).toLowerCase().split(" ").every(function (x) {
            var _item$wine, _item$wine2;
            return String.removeDiacritics(((_item$wine = item.wine) === null || _item$wine === void 0 ? void 0 : _item$wine.display_name) + " " + ((_item$wine2 = item.wine) === null || _item$wine2 === void 0 ? void 0 : _item$wine2.sku)).toLowerCase().includes(x);
          }) && (!_this7.itemsSearchFromWinery || !!_this7.itemsSearchFromWinery && item.isDirectWinery) || _this7.form.newOrderItems.map(function (x) {
            return x.fromItemId;
          }).includes(item.id_item);
        });
      }
      result.map(function (item) {
        return item.isInNewOrder = _this7.form.newOrderItems.some(function (x) {
          return x.fromItemId == item.id_item;
        });
      });
      result.sort(function (a, b) {
        return b.isInNewOrder && !a.isInNewOrder ? 1 : -1;
      });
      this.itemsShown = result;
    },
    pickAllItems: function pickAllItems() {
      var _this8 = this;
      this.itemsSearchLabel = "";
      this.itemsSearch();
      this.itemsShown.forEach(function (item) {
        _this8.changeQuantityForOrder(item, item.quantity / item.casingId.match(/\d+/)[0]);
      });
    },
    unpickAllItems: function unpickAllItems() {
      var _this9 = this;
      this.itemsSearchLabel = "";
      this.itemsSearch();
      this.itemsShown.forEach(function (item) {
        _this9.changeQuantityForOrder(item, 0);
      });
    },
    changeQuantityNewOrder: function changeQuantityNewOrder(item, nbCases) {
      var nbBottles = nbCases * item.casingId.match(/\d+/)[0];
      if (nbBottles <= item.quantity) {
        if (nbBottles > 0) {
          if (this.form.newOrderItems.some(function (x) {
            return x.fromItemId === item.id_item;
          })) {
            this.form.newOrderItems.find(function (x) {
              return x.fromItemId === item.id_item;
            }).nbBottles = nbBottles;
          } else {
            this.form.newOrderItems = [].concat(_toConsumableArray(this.form.newOrderItems), [{
              fromItemId: item.id_item,
              nbBottles: nbBottles,
              originalItem: item
            }]);
          }
        } else {
          var itemToRemove = this.form.newOrderItems.find(function (x) {
            return x.fromItemId === item.id_item;
          });
          if (itemToRemove) {
            this.form.newOrderItems.splice(this.form.newOrderItems.indexOf(itemToRemove), 1);
          }
        }
        this.itemsSearch();
      }
      this.quantityToggleKey = !this.quantityToggleKey;
    },
    computeAddressStockConsignment: function computeAddressStockConsignment(item) {
      if (item.wine.stock_storage_continent_iso2) {
        return " stored in " + listContinents.find(function (x) {
          return x.id == item.wine.stock_storage_continent_iso2;
        }).display_name;
      } else {
        return item.wineryAddress.city + (item.wineryAddress.zip ? " " + item.wineryAddress.zip : "") + ", " + item.wineryAddress.country.printable_name + (item.wineryAddress.state.id_state ? " " + item.wineryAddress.state.state_label : "");
      }
    },
    isItemPoDanger: function isItemPoDanger(lowestStatusPo) {
      return lowestStatusPo.status === purchaseOrder.status.DRAFT;
    },
    isItemPoWarning: function isItemPoWarning(lowestStatusPo, itemQty) {
      return lowestStatusPo.status === purchaseOrder.status.OPEN && lowestStatusPo.receiptStatus === purchaseOrder.receiptStatus.AWAITING || lowestStatusPo.quantity < itemQty;
    },
    isItemPoSuccess: function isItemPoSuccess(lowestStatusPo, itemQty) {
      return (lowestStatusPo.status === purchaseOrder.status.OPEN || lowestStatusPo.status === purchaseOrder.status.CLOSED) && lowestStatusPo.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && lowestStatusPo.quantity === itemQty;
    },
    getItemPoStatus: function getItemPoStatus(item) {
      var lowestStatusPo = this.getLowestStatusPurchaseOrder(item);
      if (this.isItemPoDanger(lowestStatusPo)) return "danger";
      if (this.isItemPoWarning(lowestStatusPo, item.quantity)) return "warning";
      if (this.isItemPoSuccess(lowestStatusPo, item.quantity)) return "success";
    },
    getLowestStatusPurchaseOrder: function getLowestStatusPurchaseOrder(item) {
      if (item.associatedPurchaseOrders.find(function (x) {
        return x.status === purchaseOrder.status.DRAFT;
      })) return item;
      var itemQtyNotFilled = item.associatedPurchaseOrders.find(function (x) {
        return x.quantity < item.quantity;
      });
      if (itemQtyNotFilled) return itemQtyNotFilled;
      return item.associatedPurchaseOrders.find(function (x) {
        return x.status === Math.min.apply(Math, _toConsumableArray(item.associatedPurchaseOrders.map(function (x) {
          return x.status;
        }))) && x.receiptStatus === Math.min.apply(Math, _toConsumableArray(item.associatedPurchaseOrders.map(function (x) {
          return x.receiptStatus;
        })));
      });
    },
    initStep: function initStep() {
      var stepId = 1;
      this.steps = [{
        id: stepId,
        key: "items",
        title: "New order creation",
        inf: "pick the missing items to create the new order"
      }, {
        id: stepId + 1,
        key: "mail",
        title: "Send e-mail(s)",
        inf: "Select an email template and targets to inform stakeholders."
      }, {
        id: stepId + 2,
        key: "synthesis",
        title: "Synthesis"
      }];
      this.currentStep = 1;
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    changePanel: function changePanel() {
      var _this10 = this;
      if (document.querySelector("#expansion-panel_".concat(this.openedPanel && this.openedPanel - 1))) {
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(_this10.openedPanel && _this10.openedPanel - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      }
    },
    deleteTemplatePanel: function deleteTemplatePanel(index) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this11.$refs.confirm.open("Confirm", "Are you sure you want to delete the configuration of this e-mail?");
            case 2:
              isConfirmed = _context8.sent;
              if (isConfirmed) {
                _this11.form.emailTemplates.splice(index, 1);
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee7);
      }))();
    },
    syncLatestVersion: function syncLatestVersion() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var selectedTemplate, current;
        return _regeneratorRuntime().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this12.isSyncing = true;
              _context9.next = 3;
              return _this12.fetchEmailTemplates();
            case 3:
              selectedTemplate = _this12.form.emailTemplates[_this12.openedPanel];
              if (!!selectedTemplate.id) {
                current = _this12.emailTemplates.find(function (x) {
                  return x.id === selectedTemplate.id;
                });
                _this12.changeTemplate(current);
              }
              _this12.isSyncing = false;
              _this12.isNeedingSync = false;
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee8);
      }))();
    },
    replaceSymbol: function replaceSymbol(value) {
      var _this$flattenPlacehol;
      return ((_this$flattenPlacehol = this.flattenPlaceholders.find(function (x) {
        return x.symbol === value;
      })) === null || _this$flattenPlacehol === void 0 ? void 0 : _this$flattenPlacehol.filledValue) || "";
    },
    closeTemplateModal: function closeTemplateModal() {
      var _this13 = this;
      this.editableTemplate = {};
      this.$nextTick(function () {
        return _this13.templateModalShown = false;
      });
    },
    newTemplate: function newTemplate() {
      var _this14 = this;
      this.$nextTick(function () {
        return _this14.templateModalShown = true;
      });
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(this.replaceSymbol(item.symbol));
    },
    saveTemplate: function saveTemplate(template, success, fail) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this = _this15;
              _context10.next = 3;
              return request("/v1/mail/templates", !!template.id ? "put" : "post", template, true, "api").catch(function (e) {
                var _e$response$data;
                if ((_e$response$data = e.response.data) !== null && _e$response$data !== void 0 && _e$response$data.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                } else {
                  _this.$toasted.show("Unable to save the new template.", {
                    type: "error"
                  });
                }
                fail();
                throw e;
              });
            case 3:
              _this15.$toasted.show("Template saved.", {
                type: "success"
              });
              if (!!template.id) _this15.isNeedingSync = true;else _this15.fetchEmailTemplates();
              success();
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee9);
      }))();
    },
    deleteTemplate: function deleteTemplate(templateId) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var isConfirmed, _this, rest;
        return _regeneratorRuntime().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this16.$refs.confirm.open("Confirm", "Are you sure you want to remove it permanently?");
            case 2:
              isConfirmed = _context11.sent;
              if (!isConfirmed) {
                _context11.next = 14;
                break;
              }
              _this16.isDeletingTemplate = true;
              _this = _this16;
              _context11.next = 8;
              return request("/v1/mail/templates/".concat(templateId), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to delete this template.", {
                  type: "error"
                });
                _this.isDeletingTemplate = false;
                throw e;
              });
            case 8:
              _context11.next = 10;
              return _this16.fetchEmailTemplates();
            case 10:
              rest = _this16.form.emailTemplates.filter(function (x) {
                return x.id === templateId;
              });
              _this16.form.emailTemplates = _toConsumableArray(rest.length > 0 ? rest : [{
                id: 0,
                files: [],
                sendTo: [],
                mailHistories: []
              }]);
              _this16.editableTemplate = {};
              _this16.isDeletingTemplate = false;
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee10);
      }))();
    },
    editTemplate: function editTemplate(id) {
      this.templateModalShown = true;
      var template = this.emailTemplates.find(function (x) {
        return x.id === id;
      });
      this.editableTemplate = _objectSpread({}, template);
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this = _this17;
              _context12.next = 3;
              return request("/v1/mail/templates", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to fetch email templates.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context12.sent;
              _this17.emailTemplates = _toConsumableArray(response.data).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  files: [],
                  sendTo: []
                });
              });
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee11);
      }))();
    },
    fetchEmailPlaceholders: function fetchEmailPlaceholders() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var response;
        return _regeneratorRuntime().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return request("/v1/mail/placeholders?orderId=".concat(_this18.order.id_order), "get", null, true, "api");
            case 2:
              response = _context13.sent;
              _this18.emailPlaceholders = response.data;
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee12);
      }))();
    },
    newEmail: function newEmail() {
      var _this19 = this;
      this.form.emailTemplates = [].concat(_toConsumableArray(this.form.emailTemplates), [{
        id: 0,
        sendTo: [],
        files: [],
        mailHistories: []
      }]);
      this.$nextTick(function () {
        var i = _this19.form.emailTemplates.length - 1;
        _this19.openedPanel = i;
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(i && i - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      });
    },
    changeTemplate: function changeTemplate(item) {
      var reduce = function reduce(acc, x) {
        return acc.replaceAll(x.symbol, x.filledValue);
      };
      this.form.emailTemplates.splice(this.openedPanel, 1, _objectSpread(_objectSpread({}, item), {}, {
        subject: this.flattenPlaceholders.reduce(reduce, item.subject),
        htmlContent: this.flattenPlaceholders.reduce(reduce, item.htmlContent)
      }));
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this20.isLoadingFiles = true;
              _this = _this20;
              _context14.next = 4;
              return request("/v1/orders/" + _this20.order.id_order + "/docs", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context14.sent;
              _this20.documents = response.data.reduce(function (acc, x) {
                return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                  children: _toConsumableArray(x.document_urls)
                })]);
              }, []);
              _this20.isLoadingFiles = false;
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }))();
    },
    clickOutsideDrawer: function clickOutsideDrawer() {
      this.drawer = this.isStatelessDrawer && this.isShown;
    },
    close: function close() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              isConfirmed = true;
              if (_this21.hasFailedSending) {
                _context15.next = 5;
                break;
              }
              _context15.next = 4;
              return _this21.$refs.confirm.open("Cancel", "Are you sure you want to cancel the split ?");
            case 4:
              isConfirmed = _context15.sent;
            case 5:
              if (isConfirmed) {
                _this21.currentStep = 1;
                _this21.isStatelessDrawer = false;
                _this21.drawer = false;
                _this21.$emit("close", true);
                _this21.isStatelessDrawer = true;
              }
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee14);
      }))();
    },
    wineNaming: wineNaming
  }
};